module.exports = __webpack_public_path__ + "img/banner.a1f77c62.jpg";